import { render, staticRenderFns } from "./LifeInsuranceProfessionallyArrangedYN.vue?vue&type=template&id=6cd1aca8"
import script from "./LifeInsuranceProfessionallyArrangedYN.vue?vue&type=script&lang=js"
export * from "./LifeInsuranceProfessionallyArrangedYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports